module.exports = __webpack_public_path__ + "img/crown-2.647b976.png";